var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CurriculumReadEECPure',{attrs:{"student-user-id":_vm.studentUserId,"ee-curriculum":_vm.eeCurriculum,"journal-trees":_vm.journalTrees,"files-view-journal":_vm.filesViewJournal,"select-files-view-journal":_vm.selectFilesViewJournal}})}
var staticRenderFns = []

export { render, staticRenderFns }